import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChallenge } from 'src/hook/data/useChallenge';
import { useLearning } from 'src/hook/data/useLearning';
import { WordData } from 'src/model/WordData';
import { useLearnWizard } from '../../../../hook/components/useLearnWizard';
import { LearnWizardStep, PageSource } from '../../../../model/enum/enums';
import { Word } from '../../../../model/Word';
import SkipModal from '../SkipModal/SkipModal';
import styles from './ActionButtons.module.scss';

interface ActionButtonsProps {
    word: Word;
    wordData: WordData;
}

const ActionButtons = ({ word, wordData }: ActionButtonsProps) => {
    const { open, setAutoPlay } = useLearnWizard();
    const { setAutoPlay: setAutoPlayChallenge } = useChallenge();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { remembered } = useLearning();
    const { t } = useTranslation();

    const handleLearn = () => {
        open(LearnWizardStep.First, { word, wordData, pageSource: PageSource.Learn });
        setTimeout(() => remembered(word.ID), 0);
    };

    const handleSkip = () => {
        setIsModalOpen(true);
        setAutoPlay(false);
        setAutoPlayChallenge(false);
    };

    return (
        <div className={styles.actionButtons}>
            <button className={styles.learnButton} onClick={handleLearn}>
                {t('Learn')}
            </button>
            <button className={styles.skipButton} onClick={handleSkip}>
                {t('Skip')}
            </button>
            <SkipModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                word={word}
                handleLearn={handleLearn}
            />
        </div>
    );
};

export default ActionButtons;